import { Typography, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";
import usePageTitle from "../../../Common/hooks/usePageTitle";
import TopBar from "../../../Layout/components/TopBar/TopBar";
import PackageEditForm from "../components/PackageEditForm/PackageEditForm";
import styles from "./PackageEditView.module.scss";

const PackageEditView = (): JSX.Element => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    usePageTitle("Admin | Edit Package");

    const handleBack = () => {
        navigate("/admin/packages");
    };

    if (!id) {
        return <div>Invalid package ID</div>;
    }

    return (
        <div id="packageedit" data-testid="packageedit" style={{ height: "100%" }}>
            <TopBar>
                <div className={styles.details__topBarContainer}>
                    <IconButton onClick={handleBack} sx={{ mr: 2 }}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h4">Edit Package</Typography>
                </div>
            </TopBar>

            <PackageEditForm packageId={id} />
        </div>
    );
};

export default PackageEditView;